export const messages = {
  en: {
    repairTypeUser: {
      title: 'Repair Master',
      repairMasterId: 'Repair Master ID',
      masterName: 'Master Name',
      repairType: 'Repair Type',
      status: 'Status',
      description: 'Description',
      createTime: 'Create Time',
      operation: 'Operation',
      repairTypeRequired: 'Repair type is required'
    },
    deleteRepairTypeUser: {
      title: 'Confirm Operation',
      confirmDelete: 'Are you sure to delete this repair master?'
    },
    editRepairTypeUser: {
      title: 'Modify Repair Master',
      status: 'Status',
      description: 'Description',
      online: 'Online',
      offline: 'Offline',
      descriptionPlaceholder: 'Optional, please enter description',
      statusRequired: 'Status is required'
    }
  },
  zh: {
    repairTypeUser: {
      title: '报修师傅',
      repairMasterId: '维修师傅ID',
      masterName: '师傅名称',
      repairType: '报修类型',
      status: '状态',
      description: '说明',
      createTime: '创建时间',
      operation: '操作',
      repairTypeRequired: '未包含报修类型'
    },
    deleteRepairTypeUser: {
      title: '请确认您的操作',
      confirmDelete: '确定删除报修师傅?'
    },
    editRepairTypeUser: {
      title: '变更报修师傅',
      status: '状态',
      description: '说明',
      online: '在线',
      offline: '离线',
      descriptionPlaceholder: '选填，请填写说明',
      statusRequired: '状态不能为空'
    }
  }
}